import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recurring',
  templateUrl: './recurring.component.html',
  styleUrls: ['./recurring.component.sass']
})
export class RecurringComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
